<template>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">编辑资料</span>
        </v-card-title>
        <div v-if="loading" class="d-flex justify-center my-4">
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
        <v-card-text v-else>
            <label class="v-label theme--light blue--text text-h6">
                档案名称 : {{ material.filename }}
            </label>
          <v-form ref="form" v-model="valid">
            <v-select
              v-model="selectedCategoryId"
              :items="categories"
              label="选择目录"
              item-text="name"
              item-value="categoryId"
              required
            ></v-select>
            <v-select
              v-model="selectedTagIds"
              :items="tags"
              label="标签"
              item-text="name"
              item-value="id"
              multiple
              chips
              deletable-chips
            ></v-select>
            <v-file-input
              v-model="file"
              label="更新文件"
              accept=".pdf,.doc,.docx"
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="close">取消</v-btn>
          <v-btn color="blue darken-1" text @click="updateMaterial">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { materialApi } from '@/api/material'
  
  export default {
    data() {
      return {
        dialog: false,
        valid: false,
        loading: false,
        // 目录列表
        categories: [],
        // 标签目录
        tags: [],
        selectedCategoryId: null,
        selectedTagIds: [],
        addTagIds: [],
        removeTagIds: [],
        previousTagIds: [],
        file: null,
        material: { filename: null},
        materialId: null,
      }
    },
    methods: {
      async open(material) {
        this.loading = true;
        this.material = material;
        this.materialId = material.id;
        this.dialog = true;
        try {
            await this.fetchMaterialDetails(material.id);
            await this.fetchCategories();
            await this.fetchTags();
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || '未知错误';
            this.$toast.error('获取详情失败：' + errorMessage);
        } finally {
            this.loading = false;
        }
      },
      close() {
        this.dialog = false;
        this.resetForm();
      },
      async fetchMaterialDetails(id) {
        try {
            const response = await materialApi.getMaterialDetails(id);
            const { interviewData, tags } = response.data;
            this.selectedCategoryId = interviewData.categoryId;
            this.selectedTagIds = tags.map(tag => tag.id);
            // 在 mounted 阶段初始化 previousTagIds，避免 watch 误触发
            this.previousTagIds = [...this.selectedTagIds];
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || '未知错误';
          this.$toast.error('获取资料信息失败：' + errorMessage)
      }
        
      },
      async fetchCategories() {
        try {
            const response = await materialApi.getCategories();
            this.categories = response.data;
        } catch(error) {
            this.$toast.error('获取资料信息失败：' + error.message);
        }
      },
      async fetchTags() {
        const response = await materialApi.getTags();
        this.tags = response.data;
      },
      async updateMaterial() {
        const formData = new FormData();
        formData.append('file', this.file);
        const response = await materialApi.updateMaterial(this.materialId, {
          newCategoryId: this.selectedCategoryId,
          visible: true,
          addTagIds: this.addTagIds,
          removeTagIds: this.removeTagIds,
          file: this.file,
        });
        console.log('update material response = ', response);
        this.$emit('update-material');
        this.$toast.success('资料信息更新成功');
        this.close();
      },
      resetForm() {
        this.selectedCategoryId = null;
        this.selectedTagIds = [];
        this.file = null;
        this.addTagIds = [];
        this.removeTagIds = [];
        this.previousTagIds = [];
      }
    },
    watch: {
        selectedTagIds(newSelectedTagIds, oldSelectedTagIds) {
            if (!oldSelectedTagIds) return; // 避免 undefined 影响

            // console.log('newSelectedTagIds = ', newSelectedTagIds);
            // console.log('oldSelectedTagIds = ', oldSelectedTagIds);
            // console.log('firtst previousTagIds = ', this.previousTagIds);
            // 计算新增的 tagIds
            const newAddTagIds = newSelectedTagIds.filter(id => !this.previousTagIds.includes(id));
            this.addTagIds = [...this.addTagIds, ...newAddTagIds];

            // 计算移除的 tagIds
            const newRemoveTagIds = this.previousTagIds.filter(id => !newSelectedTagIds.includes(id));
            this.removeTagIds = [...this.removeTagIds, ...newRemoveTagIds];

            // 更新 previousTagIds
            this.previousTagIds = [...newSelectedTagIds];

            // console.log('previousTagIds = ', this.previousTagIds);
            // console.log('selectedTagIds = ', newSelectedTagIds);
            // console.log('addTagIds = ', this.addTagIds);
            // console.log('removeTagIds = ', this.removeTagIds);
        }
    }
  }
  </script>